// Fixed brand names (DESIGN-SYSTEM §9, SPEC §1.1). They are identity, shown in both languages at once, not interface copy, so they live
// here rather than in a locale file. «إيكونيك — مركز الذكاء الاقتصادي» is pending MoET review (dep, DESIGN-SYSTEM §20). WP-THEME.
export const MINISTRY_NAME = { en: "Ministry of Economy & Tourism", ar: "وزارة الاقتصاد والسياحة" } as const;
export const PRODUCT_NAME = { en: "ECONIC", ar: "إيكونيك" } as const;
export const PRODUCT_TAGLINE = { en: "MoET’s Intelligence Centre", ar: "إيكونيك — مركز الذكاء الاقتصادي" } as const;

/** Brand files in apps/assistant/public/brand/ (from D/brand/; vector masters of the emblem and wordmark are a MoET dependency). */
export const BRAND = {
  wordmark: "/brand/econic-wordmark.svg",
  wordmarkReverse: "/brand/econic-wordmark-reverse.svg",
  mark: "/brand/econic-mark.svg",
  favicon: "/brand/econic-favicon.svg",
  emblem: "/brand/moet-emblem.png",
  /** The bar emblem, pre-scaled (Lanczos + a light unsharp mask) at 1× / 2× / 3× for its 22 px height (APPLE-SPEC §5.2). */
  emblem22: "/brand/moet-emblem-22.png",
  emblem44: "/brand/moet-emblem-44.png",
  emblem66: "/brand/moet-emblem-66.png",
  lockupEn: "/brand/moet-logo-en.png",
  lockupAr: "/brand/moet-logo-ar.png",
} as const;

/** Intrinsic sizes, so every image reserves its box before it loads (no layout shift). */
export const BRAND_RATIO = { wordmark: 788.8 / 158.9, emblem: 175 / 228, lockup: 907 / 228 } as const;
